import { IRestaurantNode, useGetFavoriteRestaurantsQuery } from 'generated/graphql-gateway';
import { useAuthContext } from 'state/auth';

export const useGetFavoriteRestaurants = () => {
  const { isAuthenticated, user } = useAuthContext();

  const { data, loading, error } = useGetFavoriteRestaurantsQuery({
    variables: {
      input: {
        first: 20,
      },
    },
    skip: !isAuthenticated || !user?.cognitoId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    restaurants: (data?.favoriteRestaurants?.nodes as IRestaurantNode[]) || [],
    loading,
    error,
  };
};
